<template>
  <div>
    <div class="banner"  v-if="company">
      <p>{{ company.slogan }}</p>
    </div>

    <div>
      <div class="contact-us-page">
        <div class="contact-us-container">
          <!-- 公司信息 -->
          <div class="contact-info" v-if="company">
            <h2>公司信息</h2>
            <div class="info-item">
              <i class="fa fa-building"></i> 公司名称：
              <p>{{ company.name }}</p>
            </div>
            <div class="info-item">
              <i class="fa fa-map-marker"></i> 公司地址：
              <p>{{ company.address }}</p>
            </div>
            <div class="info-item">
              <i class="fa fa-phone"></i> 联系电话：
              <p>{{ company.phone }}</p>
            </div>
            <div class="info-item">
              <i class="fa fa-envelope"></i> 电子邮箱：
              <p>{{ company.email }}</p>
            </div>
          </div>

          <!-- 联系我们表单 -->
          <div class="contact-form">
            <h1>联系我们</h1>
            <form @submit.prevent="submitForm">
              <div>
                <label for="name">姓名:</label>
                <input type="text" id="name" v-model="form.name" required />
              </div>
              <div>
                <label for="company">公司:</label>
                <input type="text" id="company" v-model="form.company" />
              </div>
              <div>
                <label for="email">电子邮箱:</label>
                <input type="email" id="email" v-model="form.email" required />
              </div>
              <div>
                <label for="phone">联系电话:</label>
                <input type="tel" id="phone" v-model="form.phone" required />
              </div>
              <div>
                <label for="message">内容:</label>
                <textarea id="message" v-model="form.message" required></textarea>
              </div>
              <button type="submit">提交</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCompanyInfo } from "@/api/company"; // 你需要在 api 目录下实现
import { addUserContact }from "@/api/contact";
import axios from "axios";
export default {
  
  data() {
    return {
      company: null, // 动态公司信息
      form: {
        name: "",
        company: "",
        email: "",
        phone: "",
        message: "",
      },
    };
  },
  methods: {
    async fetchCompanyInfo() {
      try {
        const res = await getCompanyInfo();
        if (res.data && res.data.status === 200) {
          this.company = res.data.data; // 后端返回 { id, name, address, phone, email }
          console.log("公司信息:", this.company);
        } else {
          console.error("获取公司信息失败:", res.data.msg);
        }
      } catch (error) {
        console.error("请求公司信息异常:", error);
      }
    },
    async submitForm() {
      try {
        const response = await axios.post(
          this.$serverUrl + "api/addUserContact/",
          this.form,
          {
            headers: { "Content-Type": "application/json" }
          }
        );
        if (response.data.status === 200) {
          this.$message.success("提交成功，感谢您的信任与支持！");
          this.resetForm();
        } else {
          this.$message.error(response.data.msg || "提交失败，请稍后再试。");
        }
      } catch (error) {
        console.error("表单提交异常:", error);
        this.$message.error("提交失败，请稍后再试。");
      }
    },
    // async submitForm() {
    //   try {
    //     const response = await addUserContact(this.form);
    //     if (response.data.status === 200) {
    //       this.$message.success("提交成功，感谢您的信任与支持！");
    //       this.resetForm();
    //     } else {
    //       this.$message.error(response.data.msg || "提交失败，请稍后再试。");
    //     }
    //   } catch (error) {
    //     console.error("表单提交异常:", error);
    //     this.$message.error("提交失败，请稍后再试。");
    //   }
    // },
    resetForm() {
      this.form = {
        name: "",
        company: "",
        email: "",
        phone: "",
        message: "",
      };
    },
  },
  mounted() {
    this.fetchCompanyInfo();
  },
};
</script>


<style scoped>
	
	.banner {
  height: 200px;
  line-height: 200px;
  color: #fff;
  background-image: url("../../assets/images/connect.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  text-align: center;
  font-size: 1em;
  margin-bottom: 50px;
}
	
.contact-us-page {
  padding: 20px;
}

.contact-us-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 30px;
  width: 70%;
  margin: auto;
}

.contact-info {
  /* max-width: 300px; */
  width: 20%;
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.contact-info h2 {
  margin-bottom: 15px;
}

.contact-info p {
  margin: 5px 0;
}

.social-media {
  margin-top: 15px;
}

.social-media a {
  margin: 0 10px;
}

.social-media img {
  width: 30px;
  height: 30px;
  transition: transform 0.3s;
}

.social-media img:hover {
  transform: scale(1.2);
}

.contact-form {
  /* max-width: 600px; */
  width: 70%;
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.contact-form h1 {
  text-align: center;
  margin-bottom: 20px;
}

.contact-form form div {
  margin-bottom: 15px;
}

.contact-form form label {
  display: block;
  margin-bottom: 5px;
}

.contact-form form input,
.contact-form form textarea {
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #ccc;
  box-sizing: border-box;
}

.contact-form form textarea {
  height: 100px;
  resize: none;
}

.contact-form form button {
  width: 100%;
  padding: 12px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1em;
  transition: background-color 0.3s;
}

.contact-form form button:hover {
  background-color: #0056b3;
}


.contact-info {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.contact-info h2 {
  font-size: 2em;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

.info-item {
  /* display: flex; */
  align-items: center;
  margin-bottom: 25px;
  color: #555;
}

.info-item i {
  margin-right: 10px;
  color: #007bff;
  font-size: 1.2em;
}

.info-item p {
  margin: 0;
  margin-top: 5px;
  font-size: 1.1em;
  line-height: 2;
}

@media (max-width: 768px) {
  .contact-info {
    padding: 15px;
  }
  
  .contact-info h2 {
    font-size: 1.5em;
  }

  .info-item p {
    font-size: 0.9em;
  }
}

</style>
